var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VRow',[_vm._l((_setup.getCommunesGroupItems),function(item,key){return [_c('VCol',{key:`Commune${key}`,staticClass:"py-3",attrs:{"cols":"12","lg":"3","md":"4","sm":"6","xs":"12"}},[_c(_setup.CommuneGroupItem,{attrs:{"communeGroup":item}})],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }